/**
 * Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import { simplyClick, validateName } from "../../helpers";
import ButtonGroup from "../ButtonGroup";
import InputGlobal from "../InputGlobal";

/**
 *Styles
 */
import "./Name.scss";
import StepWrapper from "../StepWrapper";
import ButtonGlobal from "../ButtonGlobal";

const Name = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorName, setErrorName] = useState(null);

  const handlerSubmit = () => {
    const { status, error } = validateName(data?.first_name);

    if (!status) {
      setErrorName(error);
    } else {
      setStep(step + 1);
      simplyClick("cl_lnd_am31_name_cont", { first_name: data?.first_name });
    }
  };

  const handleChangeName = (e) => {
    setErrorName(null);
    setData({ ...data, first_name: e.target.value });
  };

  const handlerStepBack = () => {
    setStep(step - 1);
    simplyClick("cl_lnd_am31_name_back", null);
  };

  return (
    <StepWrapper step={step} stepLabel={"What is your name?"}>
      <div className="name__input">
        <div className="has-float-label">
          <InputGlobal
            className={"input__global" + (errorName ? " error" : "")}
            onChange={(e) => handleChangeName(e)}
            name={"name__31"}
            placeholder={"Name"}
            type={"text"}
            id={"name__30"}
            value={data.first_name ? data.first_name : ""}
          />
          <label htmlFor="name__31" className={errorName ? "error" : ""}>
            Name
          </label>
        </div>
        {errorName && <p className="error-text">{errorName}</p>}
      </div>
      <div className="button_wrap">
        <ButtonGlobal text={"Continue"} cb={handlerSubmit} />
        <ButtonGlobal
          text={"Back"}
          cb={handlerStepBack}
          back={true}
          iconLeft={true}
        />
      </div>
    </StepWrapper>
  );
};

export default Name;
